<app-loader *ngIf="isLoading"></app-loader>
<div class="py-4 px-3">
    <div class="flex justify-center items-center py-2">
        <h1 class="font-bold text-4xl text-center ml-2">Sensor Dashboard</h1>
        <h1 class="text-4xl font-bold ml-2"><svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24"
                stroke-linecap="round" stroke-linejoin="round" height="1em" width="1em"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M3 3v16a2 2 0 0 0 2 2h16"></path>
                <path d="M7 16c.5-2 1.5-7 4-7 2 0 2 3 4 3 2.5 0 4.5-5 5-7"></path>
            </svg></h1>
    </div>
    <div class="px-3">
        <div class="box py-2">
            <form class="push mr-2 mt-4 flex items-center" [formGroup]="myForm" (ngSubmit)="onSubmit()">
                <select name="labNames" id="organizationDropdown" formControlName="org" (change)="onChangeOrg($event)"
                    [ngClass]="{ 'input-error': myForm.get('org')?.invalid && (myForm.get('org')?.touched || myForm.get('org')?.dirty) }"
                    class="btn-2 border-gray-200 rounded-lg mr-2 input-style org-name">
                    <option value="" class="org-name">All Organizations</option>
                    <ng-container>
                        <option *ngFor="let item of orgList" [value]="item.organization_id">{{item.organization_name}}
                        </option>
                    </ng-container>
                </select>
                <select name="labNames" formControlName="device" (change)="onChangeDevice($event)"
                    [ngClass]="{'input-error': myForm.get('device')?.invalid && (myForm.get('device')?.touched || myForm.get('device')?.dirty) }"
                    class="btn-2 border-gray-200 rounded-lg mr-2 input-style org-name">
                    <option value="" class="org-name input-style">Select Device</option>
                    <ng-container>
                        <option *ngFor="let item of deviceList" [value]="item.thing_name">{{ item.device_name }}
                        </option>
                    </ng-container>
                </select>

                <!-- <select name="" id="" *ngIf="setDefaultDevice" class="btn-2 border-gray-200 rounded-lg mb-5  mr-2 input-style org-name">
        <option [value]="bindDevice.thing_name" class="org-name input-style" selected disabled>{{bindDevice.device_name}}</option>
      </select> -->

                <select name="roleType" id="applicationDropdown" formControlName="applications"
                    (change)="onChangeApplications($event)"
                    [ngClass]="{'input-error': myForm.get('applications')?.invalid && (myForm.get('applications')?.touched || myForm.get('applications')?.dirty) }"
                    class="btn-2 mr-2 border-gray-200 rounded-lg input-style lab-name">
                    <option value="" class="org-name input-style">Select Applications</option>
                    <ng-container>
                        <option *ngFor="let item of applicationsList" [value]="item.application_identifier">
                            {{ item.application_name }}
                        </option>
                    </ng-container>
                </select>

                <!-- <select name="" id="" *ngIf="setDefaultApplication" class="btn-2 border-gray-200 rounded-lg mb-5  mr-2 input-style org-name">
        <option [value]="bindApplication.application_identifier" class="org-name input-style" selected disabled>{{bindApplication.application_name}}</option>
      </select> -->

                <select name="roleType" id="" class="btn-2 mr-2 border-gray-200 rounded-lg input-style lab-name"
                    (change)="onChangeDate($event)">
                    <ng-container>
                        <option *ngFor="let item of filterBydate" [value]="item.value">{{item.display}}</option>
                    </ng-container>
                    <option value="last_7_days" class="org-name input-style">Last 7 days</option>
                </select>
                <button
                    class="btn-3 bg-greenish-blue text-white p-2 rounded-lg shadow-xl hover:bg-red-600 get-data">
                    Get Data
                </button>
            </form>
        </div>

        <div *ngIf="showSensorsCheckboxes"
            class="p-2 flex justify-around bg-white border-slate-200 category-div text-right mb-4 mt-4">
            <div class="flex justify-center items-center filter-charts">
                <h1 style="font-size: 18px; font-weight: 600;">Filter Charts by Sensors</h1>
                <h1 class="ml-2"><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512"
                        height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M487.976 0H24.028C2.71 0-8.047 25.866 7.058 40.971L192 225.941V432c0 7.831 3.821 15.17 10.237 19.662l80 55.98C298.02 518.69 320 507.493 320 487.98V225.941l184.947-184.97C520.021 25.896 509.338 0 487.976 0z">
                        </path>
                    </svg></h1>
            </div>
            <div *ngFor="let sensor of sensorsList" class="flex items-center">
                <input type="checkbox" id="sensor-checkbox-{{sensor}}" checked
                    class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
                <h1 class="sensor-list">
                    {{ sensor }}
                </h1>
            </div>
        </div>

        <div *ngIf="landingContent" class="landingContent">
            <div>
                <h1 class="text-4xl font-bold">Create Dashboard by selecting mandatory fields!</h1>
                <h2 class="text-center text-4xl">(Organization, Device, Application)</h2>
            </div>
        </div>

        <div *ngIf="noSensorsFound" class="landingContent">
            <div>
                <h1 class="text-4xl font-bold">No Sensors were found for this Application</h1>
            </div>
        </div>

        <div *ngIf="showTitle" class="text-center w-full mx-auto mb-2 mt-4">
            <h1 class="text-3xl font-semibold" style="color: #01395e;">{{displayApplicationName}}</h1>
        </div>

        <div *ngIf="noData" class="noSensorValues">
            <div>
                <h1 style="font-size: 40px; font-weight: 600;">No sensor data detected in the selected time frame!</h1>
            </div>
        </div>

        <div class="scroll-bar">
            <div id="charts-container" class="charts-row">
            </div>
        </div>
    </div>

</div>